const data = {
  "v": "5.12.1",
  "fr": 25,
  "ip": 0,
  "op": 199,
  "w": 2000,
  "h": 2000,
  "nm": "Idle 2 (banner homepage)",
  "ddd": 0,
  "assets": [],
  "layers": [
    {
      "ddd": 0,
      "ind": 1,
      "ty": 3,
      "nm": "Circles NULL",
      "parent": 6,
      "sr": 1,
      "ks": {
        "o": {
          "a": 0,
          "k": 0,
          "ix": 11
        },
        "r": {
          "a": 1,
          "k": [
            {
              "i": {
                "x": [
                  0.689
                ],
                "y": [
                  0.801
                ]
              },
              "o": {
                "x": [
                  0.302
                ],
                "y": [
                  0.194
                ]
              },
              "t": 0,
              "s": [
                0
              ]
            },
            {
              "t": 199,
              "s": [
                360
              ]
            }
          ],
          "ix": 10
        },
        "p": {
          "a": 0,
          "k": [
            864.466,
            864.465,
            0
          ],
          "ix": 2,
          "l": 2
        },
        "a": {
          "a": 0,
          "k": [
            0,
            0,
            0
          ],
          "ix": 1,
          "l": 2
        },
        "s": {
          "a": 0,
          "k": [
            100,
            100,
            100
          ],
          "ix": 6,
          "l": 2
        }
      },
      "ao": 0,
      "ip": 0,
      "op": 200,
      "st": 0,
      "bm": 0
    },
    {
      "ddd": 0,
      "ind": 2,
      "ty": 4,
      "nm": "White outline + Scale",
      "sr": 1,
      "ks": {
        "o": {
          "a": 0,
          "k": 100,
          "ix": 11
        },
        "r": {
          "a": 0,
          "k": 0,
          "ix": 10
        },
        "p": {
          "a": 0,
          "k": [
            1000,
            1000,
            0
          ],
          "ix": 2,
          "l": 2
        },
        "a": {
          "a": 0,
          "k": [
            864.466,
            864.465,
            0
          ],
          "ix": 1,
          "l": 2
        },
        "s": {
          "a": 1,
          "k": [
            {
              "i": {
                "x": [
                  0.378,
                  0.378,
                  0.667
                ],
                "y": [
                  1,
                  1,
                  1
                ]
              },
              "o": {
                "x": [
                  0.566,
                  0.566,
                  0.333
                ],
                "y": [
                  0,
                  0,
                  0
                ]
              },
              "t": 0,
              "s": [
                100,
                100,
                100
              ]
            },
            {
              "i": {
                "x": [
                  0.378,
                  0.378,
                  0.667
                ],
                "y": [
                  1,
                  1,
                  1
                ]
              },
              "o": {
                "x": [
                  0.566,
                  0.566,
                  0.333
                ],
                "y": [
                  0,
                  0,
                  0
                ]
              },
              "t": 50,
              "s": [
                104,
                104,
                100
              ]
            },
            {
              "i": {
                "x": [
                  0.378,
                  0.378,
                  0.667
                ],
                "y": [
                  1,
                  1,
                  1
                ]
              },
              "o": {
                "x": [
                  0.566,
                  0.566,
                  0.333
                ],
                "y": [
                  0,
                  0,
                  0
                ]
              },
              "t": 100,
              "s": [
                100,
                100,
                100
              ]
            },
            {
              "i": {
                "x": [
                  0.378,
                  0.378,
                  0.667
                ],
                "y": [
                  1,
                  1,
                  1
                ]
              },
              "o": {
                "x": [
                  0.571,
                  0.571,
                  0.333
                ],
                "y": [
                  0,
                  0,
                  0
                ]
              },
              "t": 150,
              "s": [
                104,
                104,
                100
              ]
            },
            {
              "t": 198.75,
              "s": [
                100,
                100,
                100
              ]
            }
          ],
          "ix": 6,
          "l": 2
        }
      },
      "ao": 0,
      "shapes": [
        {
          "ty": "gr",
          "it": [
            {
              "ind": 0,
              "ty": "sh",
              "ix": 1,
              "ks": {
                "a": 0,
                "k": {
                  "i": [
                    [
                      0,
                      -461.71
                    ],
                    [
                      461.709,
                      0
                    ],
                    [
                      0,
                      461.71
                    ],
                    [
                      -461.71,
                      0
                    ]
                  ],
                  "o": [
                    [
                      0,
                      461.71
                    ],
                    [
                      -461.71,
                      0
                    ],
                    [
                      0,
                      -461.71
                    ],
                    [
                      461.709,
                      0
                    ]
                  ],
                  "v": [
                    [
                      836,
                      0
                    ],
                    [
                      0,
                      836
                    ],
                    [
                      -836,
                      0
                    ],
                    [
                      0,
                      -836
                    ]
                  ],
                  "c": true
                },
                "ix": 2
              },
              "nm": "Path 1",
              "mn": "ADBE Vector Shape - Group",
              "hd": false
            },
            {
              "ty": "st",
              "c": {
                "a": 0,
                "k": [
                  1,
                  1,
                  1,
                  1
                ],
                "ix": 3
              },
              "o": {
                "a": 0,
                "k": 100,
                "ix": 4
              },
              "w": {
                "a": 0,
                "k": 50,
                "ix": 5
              },
              "lc": 1,
              "lj": 1,
              "ml": 10,
              "bm": 0,
              "nm": "Stroke 1",
              "mn": "ADBE Vector Graphic - Stroke",
              "hd": false
            },
            {
              "ty": "tr",
              "p": {
                "a": 0,
                "k": [
                  864.466,
                  864.465
                ],
                "ix": 2
              },
              "a": {
                "a": 0,
                "k": [
                  0,
                  0
                ],
                "ix": 1
              },
              "s": {
                "a": 0,
                "k": [
                  100,
                  100
                ],
                "ix": 3
              },
              "r": {
                "a": 0,
                "k": 0,
                "ix": 6
              },
              "o": {
                "a": 0,
                "k": 100,
                "ix": 7
              },
              "sk": {
                "a": 0,
                "k": 0,
                "ix": 4
              },
              "sa": {
                "a": 0,
                "k": 0,
                "ix": 5
              },
              "nm": "Transform"
            }
          ],
          "nm": "Group 1",
          "np": 2,
          "cix": 2,
          "bm": 0,
          "ix": 1,
          "mn": "ADBE Vector Group",
          "hd": false
        }
      ],
      "ip": 0,
      "op": 200,
      "st": 0,
      "ct": 1,
      "bm": 0
    },
    {
      "ddd": 0,
      "ind": 3,
      "ty": 4,
      "nm": "Blue",
      "parent": 1,
      "tt": 1,
      "tp": 7,
      "sr": 1,
      "ks": {
        "o": {
          "a": 0,
          "k": 80,
          "ix": 11
        },
        "r": {
          "a": 0,
          "k": -1,
          "ix": 10
        },
        "p": {
          "a": 1,
          "k": [
            {
              "i": {
                "x": 0.637,
                "y": 0.653
              },
              "o": {
                "x": 0.342,
                "y": 0.102
              },
              "t": 0,
              "s": [
                487.725,
                -497.733,
                0
              ],
              "to": [
                -81.392,
                36.676,
                0
              ],
              "ti": [
                -89.693,
                -174.073,
                0
              ]
            },
            {
              "i": {
                "x": 0.667,
                "y": 1
              },
              "o": {
                "x": 0.333,
                "y": 0.186
              },
              "t": 49,
              "s": [
                381.029,
                -209.691,
                0
              ],
              "to": [
                89.693,
                174.073,
                0
              ],
              "ti": [
                1.414,
                45.348,
                0
              ]
            },
            {
              "i": {
                "x": 0.607,
                "y": 0.182
              },
              "o": {
                "x": 0.333,
                "y": 0
              },
              "t": 105,
              "s": [
                995.757,
                -393.417,
                0
              ],
              "to": [
                -1.414,
                -45.348,
                0
              ],
              "ti": [
                71.639,
                65.693,
                0
              ]
            },
            {
              "i": {
                "x": 0.625,
                "y": 0.909
              },
              "o": {
                "x": 0.426,
                "y": 0.398
              },
              "t": 156,
              "s": [
                832.248,
                -325,
                0
              ],
              "to": [
                -71.639,
                -65.693,
                0
              ],
              "ti": [
                0,
                0,
                0
              ]
            },
            {
              "t": 199,
              "s": [
                487.725,
                -497.733,
                0
              ]
            }
          ],
          "ix": 2,
          "l": 2
        },
        "a": {
          "a": 0,
          "k": [
            814.466,
            814.467,
            0
          ],
          "ix": 1,
          "l": 2
        },
        "s": {
          "a": 0,
          "k": [
            100,
            100,
            100
          ],
          "ix": 6,
          "l": 2
        }
      },
      "ao": 0,
      "shapes": [
        {
          "ty": "gr",
          "it": [
            {
              "ind": 0,
              "ty": "sh",
              "ix": 1,
              "ks": {
                "a": 0,
                "k": {
                  "i": [
                    [
                      0,
                      -449.817
                    ],
                    [
                      449.816,
                      0
                    ],
                    [
                      0,
                      449.817
                    ],
                    [
                      -449.817,
                      0
                    ]
                  ],
                  "o": [
                    [
                      0,
                      449.817
                    ],
                    [
                      -449.817,
                      0
                    ],
                    [
                      0,
                      -449.817
                    ],
                    [
                      449.816,
                      0
                    ]
                  ],
                  "v": [
                    [
                      934.061,
                      -178.098
                    ],
                    [
                      119.595,
                      636.367
                    ],
                    [
                      -694.87,
                      -178.098
                    ],
                    [
                      119.595,
                      -992.563
                    ]
                  ],
                  "c": true
                },
                "ix": 2
              },
              "nm": "Path 1",
              "mn": "ADBE Vector Shape - Group",
              "hd": false
            },
            {
              "ty": "gr",
              "it": [
                {
                  "ty": "tr",
                  "p": {
                    "a": 0,
                    "k": [
                      0,
                      0
                    ],
                    "ix": 2
                  },
                  "a": {
                    "a": 0,
                    "k": [
                      0,
                      0
                    ],
                    "ix": 1
                  },
                  "s": {
                    "a": 0,
                    "k": [
                      100,
                      100
                    ],
                    "ix": 3
                  },
                  "r": {
                    "a": 0,
                    "k": 0,
                    "ix": 6
                  },
                  "o": {
                    "a": 0,
                    "k": 100,
                    "ix": 7
                  },
                  "sk": {
                    "a": 0,
                    "k": 0,
                    "ix": 4
                  },
                  "sa": {
                    "a": 0,
                    "k": 0,
                    "ix": 5
                  },
                  "nm": "Transform"
                }
              ],
              "nm": "Group 1",
              "np": 0,
              "cix": 2,
              "bm": 0,
              "ix": 2,
              "mn": "ADBE Vector Group",
              "hd": false
            },
            {
              "ty": "mm",
              "mm": 4,
              "nm": "Merge Paths 1",
              "mn": "ADBE Vector Filter - Merge",
              "hd": false
            },
            {
              "ty": "fl",
              "c": {
                "a": 0,
                "k": [
                  0,
                  0.564705882353,
                  0.89019613827,
                  1
                ],
                "ix": 4
              },
              "o": {
                "a": 0,
                "k": 100,
                "ix": 5
              },
              "r": 1,
              "bm": 0,
              "nm": "Fill 1",
              "mn": "ADBE Vector Graphic - Fill",
              "hd": false
            },
            {
              "ty": "tr",
              "p": {
                "a": 0,
                "k": [
                  694.871,
                  992.567
                ],
                "ix": 2
              },
              "a": {
                "a": 0,
                "k": [
                  0,
                  0
                ],
                "ix": 1
              },
              "s": {
                "a": 0,
                "k": [
                  100,
                  100
                ],
                "ix": 3
              },
              "r": {
                "a": 0,
                "k": 0,
                "ix": 6
              },
              "o": {
                "a": 0,
                "k": 100,
                "ix": 7
              },
              "sk": {
                "a": 0,
                "k": 0,
                "ix": 4
              },
              "sa": {
                "a": 0,
                "k": 0,
                "ix": 5
              },
              "nm": "Transform"
            }
          ],
          "nm": "Group 1",
          "np": 4,
          "cix": 2,
          "bm": 0,
          "ix": 1,
          "mn": "ADBE Vector Group",
          "hd": false
        }
      ],
      "ip": 0,
      "op": 200,
      "st": 0,
      "ct": 1,
      "bm": 0
    },
    {
      "ddd": 0,
      "ind": 4,
      "ty": 4,
      "nm": "Dark blue",
      "parent": 1,
      "tt": 1,
      "tp": 7,
      "sr": 1,
      "ks": {
        "o": {
          "a": 0,
          "k": 80,
          "ix": 11
        },
        "r": {
          "a": 0,
          "k": 0,
          "ix": 10
        },
        "p": {
          "a": 1,
          "k": [
            {
              "i": {
                "x": 0.637,
                "y": 0.706
              },
              "o": {
                "x": 0.37,
                "y": 0.093
              },
              "t": 0,
              "s": [
                272.456,
                643.648,
                0
              ],
              "to": [
                -159.258,
                -26.245,
                0
              ],
              "ti": [
                71.305,
                4,
                0
              ]
            },
            {
              "i": {
                "x": 0.667,
                "y": 1
              },
              "o": {
                "x": 0.333,
                "y": 0.393
              },
              "t": 49,
              "s": [
                74.307,
                298.359,
                0
              ],
              "to": [
                -71.305,
                -4,
                0
              ],
              "ti": [
                -31.358,
                -67.693,
                0
              ]
            },
            {
              "i": {
                "x": 0.801,
                "y": 0.737
              },
              "o": {
                "x": 0.333,
                "y": 0
              },
              "t": 105,
              "s": [
                -59.234,
                573.497,
                0
              ],
              "to": [
                31.358,
                67.693,
                0
              ],
              "ti": [
                -109.782,
                3.884,
                0
              ]
            },
            {
              "i": {
                "x": 0.647,
                "y": 0.84
              },
              "o": {
                "x": 0.341,
                "y": 0.584
              },
              "t": 156,
              "s": [
                242.084,
                544.694,
                0
              ],
              "to": [
                120.355,
                -4.258,
                0
              ],
              "ti": [
                83.287,
                13.725,
                0
              ]
            },
            {
              "t": 199,
              "s": [
                272.456,
                643.648,
                0
              ]
            }
          ],
          "ix": 2,
          "l": 2
        },
        "a": {
          "a": 0,
          "k": [
            814.464,
            814.468,
            0
          ],
          "ix": 1,
          "l": 2
        },
        "s": {
          "a": 0,
          "k": [
            100,
            100,
            100
          ],
          "ix": 6,
          "l": 2
        }
      },
      "ao": 0,
      "shapes": [
        {
          "ty": "gr",
          "it": [
            {
              "ind": 0,
              "ty": "sh",
              "ix": 1,
              "ks": {
                "a": 0,
                "k": {
                  "i": [
                    [
                      0,
                      -449.817
                    ],
                    [
                      449.816,
                      0
                    ],
                    [
                      0,
                      449.817
                    ],
                    [
                      -449.817,
                      0
                    ]
                  ],
                  "o": [
                    [
                      0,
                      449.817
                    ],
                    [
                      -449.817,
                      0
                    ],
                    [
                      0,
                      -449.817
                    ],
                    [
                      449.816,
                      0
                    ]
                  ],
                  "v": [
                    [
                      826.427,
                      207.057
                    ],
                    [
                      11.962,
                      1021.522
                    ],
                    [
                      -802.504,
                      207.057
                    ],
                    [
                      11.962,
                      -607.408
                    ]
                  ],
                  "c": true
                },
                "ix": 2
              },
              "nm": "Path 1",
              "mn": "ADBE Vector Shape - Group",
              "hd": false
            },
            {
              "ty": "fl",
              "c": {
                "a": 0,
                "k": [
                  0.156862745098,
                  0.364705882353,
                  0.670588235294,
                  1
                ],
                "ix": 4
              },
              "o": {
                "a": 0,
                "k": 100,
                "ix": 5
              },
              "r": 1,
              "bm": 0,
              "nm": "Fill 1",
              "mn": "ADBE Vector Graphic - Fill",
              "hd": false
            },
            {
              "ty": "tr",
              "p": {
                "a": 0,
                "k": [
                  802.503,
                  607.412
                ],
                "ix": 2
              },
              "a": {
                "a": 0,
                "k": [
                  0,
                  0
                ],
                "ix": 1
              },
              "s": {
                "a": 0,
                "k": [
                  100,
                  100
                ],
                "ix": 3
              },
              "r": {
                "a": 0,
                "k": 0,
                "ix": 6
              },
              "o": {
                "a": 0,
                "k": 100,
                "ix": 7
              },
              "sk": {
                "a": 0,
                "k": 0,
                "ix": 4
              },
              "sa": {
                "a": 0,
                "k": 0,
                "ix": 5
              },
              "nm": "Transform"
            }
          ],
          "nm": "Group 1",
          "np": 4,
          "cix": 2,
          "bm": 0,
          "ix": 1,
          "mn": "ADBE Vector Group",
          "hd": false
        }
      ],
      "ip": 0,
      "op": 200,
      "st": 0,
      "ct": 1,
      "bm": 0
    },
    {
      "ddd": 0,
      "ind": 5,
      "ty": 4,
      "nm": "Orange",
      "parent": 1,
      "tt": 1,
      "tp": 7,
      "sr": 1,
      "ks": {
        "o": {
          "a": 0,
          "k": 100,
          "ix": 11
        },
        "r": {
          "a": 0,
          "k": 0,
          "ix": 10
        },
        "p": {
          "a": 1,
          "k": [
            {
              "i": {
                "x": 0.659,
                "y": 0.62
              },
              "o": {
                "x": 0.312,
                "y": 0.108
              },
              "t": 0,
              "s": [
                -708.298,
                -92.96,
                0
              ],
              "to": [
                -89.667,
                19.739,
                0
              ],
              "ti": [
                -47.074,
                116.199,
                0
              ]
            },
            {
              "i": {
                "x": 0.785,
                "y": 0.768
              },
              "o": {
                "x": 0.404,
                "y": 0.469
              },
              "t": 49,
              "s": [
                -568.318,
                -319.564,
                0
              ],
              "to": [
                47.074,
                -116.199,
                0
              ],
              "ti": [
                -117.503,
                58.427,
                0
              ]
            },
            {
              "i": {
                "x": 0.67,
                "y": 0.672
              },
              "o": {
                "x": 0.339,
                "y": 0.26
              },
              "t": 105,
              "s": [
                -487.077,
                -627.303,
                0
              ],
              "to": [
                117.503,
                -58.427,
                0
              ],
              "ti": [
                70.918,
                -96.908,
                0
              ]
            },
            {
              "i": {
                "x": 0.625,
                "y": 0.892
              },
              "o": {
                "x": 0.333,
                "y": 0.37
              },
              "t": 156,
              "s": [
                -439.178,
                -269.773,
                0
              ],
              "to": [
                -70.918,
                96.908,
                0
              ],
              "ti": [
                0,
                0,
                0
              ]
            },
            {
              "t": 199,
              "s": [
                -708.298,
                -92.96,
                0
              ]
            }
          ],
          "ix": 2,
          "l": 2
        },
        "a": {
          "a": 0,
          "k": [
            814.716,
            814.715,
            0
          ],
          "ix": 1,
          "l": 2
        },
        "s": {
          "a": 1,
          "k": [
            {
              "i": {
                "x": [
                  0.833,
                  0.833,
                  0.833
                ],
                "y": [
                  0.833,
                  0.833,
                  0.833
                ]
              },
              "o": {
                "x": [
                  0.167,
                  0.167,
                  0.167
                ],
                "y": [
                  0.167,
                  0.167,
                  0.167
                ]
              },
              "t": 0,
              "s": [
                100,
                100,
                100
              ]
            },
            {
              "i": {
                "x": [
                  0.833,
                  0.833,
                  0.833
                ],
                "y": [
                  0.833,
                  0.833,
                  0.833
                ]
              },
              "o": {
                "x": [
                  0.167,
                  0.167,
                  0.167
                ],
                "y": [
                  0.167,
                  0.167,
                  0.167
                ]
              },
              "t": 105,
              "s": [
                115,
                115,
                100
              ]
            },
            {
              "t": 199,
              "s": [
                100,
                100,
                100
              ]
            }
          ],
          "ix": 6,
          "l": 2
        }
      },
      "ao": 0,
      "shapes": [
        {
          "ty": "gr",
          "it": [
            {
              "ind": 0,
              "ty": "sh",
              "ix": 1,
              "ks": {
                "a": 0,
                "k": {
                  "i": [
                    [
                      0,
                      -449.817
                    ],
                    [
                      449.816,
                      0
                    ],
                    [
                      0,
                      449.817
                    ],
                    [
                      -449.817,
                      0
                    ]
                  ],
                  "o": [
                    [
                      0,
                      449.817
                    ],
                    [
                      -449.817,
                      0
                    ],
                    [
                      0,
                      -449.817
                    ],
                    [
                      449.816,
                      0
                    ]
                  ],
                  "v": [
                    [
                      521.584,
                      0
                    ],
                    [
                      -292.881,
                      814.465
                    ],
                    [
                      -1107.347,
                      0
                    ],
                    [
                      -292.881,
                      -814.465
                    ]
                  ],
                  "c": true
                },
                "ix": 2
              },
              "nm": "Path 1",
              "mn": "ADBE Vector Shape - Group",
              "hd": false
            },
            {
              "ty": "gr",
              "it": [
                {
                  "ty": "tr",
                  "p": {
                    "a": 0,
                    "k": [
                      0,
                      0
                    ],
                    "ix": 2
                  },
                  "a": {
                    "a": 0,
                    "k": [
                      0,
                      0
                    ],
                    "ix": 1
                  },
                  "s": {
                    "a": 0,
                    "k": [
                      100,
                      100
                    ],
                    "ix": 3
                  },
                  "r": {
                    "a": 0,
                    "k": 0,
                    "ix": 6
                  },
                  "o": {
                    "a": 0,
                    "k": 100,
                    "ix": 7
                  },
                  "sk": {
                    "a": 0,
                    "k": 0,
                    "ix": 4
                  },
                  "sa": {
                    "a": 0,
                    "k": 0,
                    "ix": 5
                  },
                  "nm": "Transform"
                }
              ],
              "nm": "Group 1",
              "np": 0,
              "cix": 2,
              "bm": 0,
              "ix": 2,
              "mn": "ADBE Vector Group",
              "hd": false
            },
            {
              "ty": "mm",
              "mm": 4,
              "nm": "Merge Paths 1",
              "mn": "ADBE Vector Filter - Merge",
              "hd": false
            },
            {
              "ty": "fl",
              "c": {
                "a": 0,
                "k": [
                  1,
                  0.400000029919,
                  0,
                  1
                ],
                "ix": 4
              },
              "o": {
                "a": 0,
                "k": 100,
                "ix": 5
              },
              "r": 1,
              "bm": 0,
              "nm": "Fill 1",
              "mn": "ADBE Vector Graphic - Fill",
              "hd": false
            },
            {
              "ty": "tr",
              "p": {
                "a": 0,
                "k": [
                  1107.597,
                  814.715
                ],
                "ix": 2
              },
              "a": {
                "a": 0,
                "k": [
                  0,
                  0
                ],
                "ix": 1
              },
              "s": {
                "a": 0,
                "k": [
                  100,
                  100
                ],
                "ix": 3
              },
              "r": {
                "a": 0,
                "k": 0,
                "ix": 6
              },
              "o": {
                "a": 0,
                "k": 100,
                "ix": 7
              },
              "sk": {
                "a": 0,
                "k": 0,
                "ix": 4
              },
              "sa": {
                "a": 0,
                "k": 0,
                "ix": 5
              },
              "nm": "Transform"
            }
          ],
          "nm": "Group 1",
          "np": 4,
          "cix": 2,
          "bm": 0,
          "ix": 1,
          "mn": "ADBE Vector Group",
          "hd": false
        }
      ],
      "ip": 0,
      "op": 200,
      "st": 0,
      "ct": 1,
      "bm": 0
    },
    {
      "ddd": 0,
      "ind": 6,
      "ty": 4,
      "nm": "White BG circle",
      "parent": 2,
      "sr": 1,
      "ks": {
        "o": {
          "a": 0,
          "k": 100,
          "ix": 11
        },
        "r": {
          "a": 0,
          "k": 0,
          "ix": 10
        },
        "p": {
          "a": 0,
          "k": [
            864.466,
            864.465,
            0
          ],
          "ix": 2,
          "l": 2
        },
        "a": {
          "a": 0,
          "k": [
            864.466,
            864.465,
            0
          ],
          "ix": 1,
          "l": 2
        },
        "s": {
          "a": 0,
          "k": [
            100,
            100,
            100
          ],
          "ix": 6,
          "l": 2
        }
      },
      "ao": 0,
      "shapes": [
        {
          "ty": "gr",
          "it": [
            {
              "ind": 0,
              "ty": "sh",
              "ix": 1,
              "ks": {
                "a": 0,
                "k": {
                  "i": [
                    [
                      0,
                      -461.71
                    ],
                    [
                      461.709,
                      0
                    ],
                    [
                      0,
                      461.71
                    ],
                    [
                      -461.71,
                      0
                    ]
                  ],
                  "o": [
                    [
                      0,
                      461.71
                    ],
                    [
                      -461.71,
                      0
                    ],
                    [
                      0,
                      -461.71
                    ],
                    [
                      461.709,
                      0
                    ]
                  ],
                  "v": [
                    [
                      836,
                      0
                    ],
                    [
                      0,
                      836
                    ],
                    [
                      -836,
                      0
                    ],
                    [
                      0,
                      -836
                    ]
                  ],
                  "c": true
                },
                "ix": 2
              },
              "nm": "Path 1",
              "mn": "ADBE Vector Shape - Group",
              "hd": false
            },
            {
              "ty": "st",
              "c": {
                "a": 0,
                "k": [
                  1,
                  1,
                  1,
                  1
                ],
                "ix": 3
              },
              "o": {
                "a": 0,
                "k": 100,
                "ix": 4
              },
              "w": {
                "a": 0,
                "k": 50,
                "ix": 5
              },
              "lc": 1,
              "lj": 1,
              "ml": 10,
              "bm": 0,
              "nm": "Stroke 1",
              "mn": "ADBE Vector Graphic - Stroke",
              "hd": false
            },
            {
              "ty": "fl",
              "c": {
                "a": 0,
                "k": [
                  1,
                  1,
                  1,
                  1
                ],
                "ix": 4
              },
              "o": {
                "a": 0,
                "k": 100,
                "ix": 5
              },
              "r": 1,
              "bm": 0,
              "nm": "Fill 1",
              "mn": "ADBE Vector Graphic - Fill",
              "hd": false
            },
            {
              "ty": "tr",
              "p": {
                "a": 0,
                "k": [
                  864.466,
                  864.465
                ],
                "ix": 2
              },
              "a": {
                "a": 0,
                "k": [
                  0,
                  0
                ],
                "ix": 1
              },
              "s": {
                "a": 0,
                "k": [
                  100,
                  100
                ],
                "ix": 3
              },
              "r": {
                "a": 0,
                "k": 0,
                "ix": 6
              },
              "o": {
                "a": 0,
                "k": 100,
                "ix": 7
              },
              "sk": {
                "a": 0,
                "k": 0,
                "ix": 4
              },
              "sa": {
                "a": 0,
                "k": 0,
                "ix": 5
              },
              "nm": "Transform"
            }
          ],
          "nm": "Group 1",
          "np": 3,
          "cix": 2,
          "bm": 0,
          "ix": 1,
          "mn": "ADBE Vector Group",
          "hd": false
        }
      ],
      "ip": 0,
      "op": 200,
      "st": 0,
      "ct": 1,
      "bm": 0
    },
    {
      "ddd": 0,
      "ind": 7,
      "ty": 4,
      "nm": "Mask",
      "parent": 2,
      "td": 1,
      "sr": 1,
      "ks": {
        "o": {
          "a": 0,
          "k": 100,
          "ix": 11
        },
        "r": {
          "a": 0,
          "k": 0,
          "ix": 10
        },
        "p": {
          "a": 0,
          "k": [
            864.466,
            864.465,
            0
          ],
          "ix": 2,
          "l": 2
        },
        "a": {
          "a": 0,
          "k": [
            864.466,
            864.465,
            0
          ],
          "ix": 1,
          "l": 2
        },
        "s": {
          "a": 0,
          "k": [
            100,
            100,
            100
          ],
          "ix": 6,
          "l": 2
        }
      },
      "ao": 0,
      "shapes": [
        {
          "ty": "gr",
          "it": [
            {
              "ind": 0,
              "ty": "sh",
              "ix": 1,
              "ks": {
                "a": 0,
                "k": {
                  "i": [
                    [
                      0,
                      -449.817
                    ],
                    [
                      449.816,
                      0
                    ],
                    [
                      0,
                      449.817
                    ],
                    [
                      -449.817,
                      0
                    ]
                  ],
                  "o": [
                    [
                      0,
                      449.817
                    ],
                    [
                      -449.817,
                      0
                    ],
                    [
                      0,
                      -449.817
                    ],
                    [
                      449.816,
                      0
                    ]
                  ],
                  "v": [
                    [
                      814.466,
                      0
                    ],
                    [
                      0,
                      814.465
                    ],
                    [
                      -814.466,
                      0
                    ],
                    [
                      0,
                      -814.465
                    ]
                  ],
                  "c": true
                },
                "ix": 2
              },
              "nm": "Path 1",
              "mn": "ADBE Vector Shape - Group",
              "hd": false
            },
            {
              "ty": "fl",
              "c": {
                "a": 0,
                "k": [
                  1,
                  1,
                  1,
                  1
                ],
                "ix": 4
              },
              "o": {
                "a": 0,
                "k": 100,
                "ix": 5
              },
              "r": 1,
              "bm": 0,
              "nm": "Fill 1",
              "mn": "ADBE Vector Graphic - Fill",
              "hd": false
            },
            {
              "ty": "tr",
              "p": {
                "a": 0,
                "k": [
                  864.466,
                  864.465
                ],
                "ix": 2
              },
              "a": {
                "a": 0,
                "k": [
                  0,
                  0
                ],
                "ix": 1
              },
              "s": {
                "a": 0,
                "k": [
                  100,
                  100
                ],
                "ix": 3
              },
              "r": {
                "a": 0,
                "k": 0,
                "ix": 6
              },
              "o": {
                "a": 0,
                "k": 100,
                "ix": 7
              },
              "sk": {
                "a": 0,
                "k": 0,
                "ix": 4
              },
              "sa": {
                "a": 0,
                "k": 0,
                "ix": 5
              },
              "nm": "Transform"
            }
          ],
          "nm": "Group 1",
          "np": 2,
          "cix": 2,
          "bm": 0,
          "ix": 1,
          "mn": "ADBE Vector Group",
          "hd": false
        }
      ],
      "ip": 0,
      "op": 200,
      "st": 0,
      "ct": 1,
      "bm": 0
    }
  ],
  "markers": [],
  "props": {}
};

export default data;